// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "vendor" + "-" + "457f4a87e1f07affb5fd" + ".css";
};